import { useParams } from 'react-router-dom';
import { LeftNav } from '../components/nav';
import { Job } from '../components/job';

export default function JobPage() {
  const { id } = useParams();

  return (
    <LeftNav>
      <Job id={id} />
    </LeftNav>
  );
}
